<template>
  <div class="short-container">
    <div class="row h-30 w-100">
      <div class="tag-container">
        <span
          v-for="t in tag"
          :key="t.id"
          @click.prevent="handleChangeTags(t)"
          :class="{
            'badge badge-pill badge-primary': true,
            'badge-active': activeTag === t,
          }"
          >{{ t }}</span>
        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tags',
  props: {
    tag: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      activeTag: 'all',
    };
  },
  mounted() {},
  methods: {
    handleChangeTags: function (tag) {
      this.$emit('changeTag', tag);
      this.activeTag = tag;
    },
  },
};
</script>

<style scoped>
.tag-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.badge {
  margin: 7px;
  padding: 13px;
  font-size: 14px !important;
  font-weight: 600;
  text-transform: capitalize;
  color: rgb(22, 24, 35);

  &:hover {
    cursor: pointer;
  }
}
.badge-pill {
  border-radius: 10px;
}
.badge-primary {
  background-color: rgba(22, 24, 35, 0.06) ;
}
.badge-active {
  background-color: rgb(27, 27, 27);
  color: white;
}
</style>
